var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        closeOutside: false,
        titulo: "Cruzamento de camadas",
        width: 1024
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        _vm._l(_vm.camadas, function(camada) {
          return _c(
            "div",
            _vm._l(Object.entries(camada), function(cruzamento) {
              return _c(
                "div",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "border-botton border-top",
                          attrs: { span: 24 }
                        },
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "caixa-flex" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "text-center",
                                    attrs: { span: 24 }
                                  },
                                  [_c("span", [_vm._v("Camada")])]
                                )
                              ],
                              1
                            )
                          ]),
                          _c("el-col", { attrs: { span: 16 } }, [
                            _c(
                              "div",
                              { staticClass: "caixa-flex" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "border-lefth text-center",
                                    attrs: { span: 5 }
                                  },
                                  [_c("span", [_vm._v("Área")])]
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "border-lefth text-center",
                                    attrs: { span: 5 }
                                  },
                                  [_c("span", [_vm._v("% de interseção")])]
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "border-lefth",
                                    attrs: { span: 14 }
                                  },
                                  [
                                    _c("div", [
                                      _c("span", [
                                        _vm._v("Informações adicionais")
                                      ])
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c(
                          "div",
                          { staticClass: "heigth-100 top-titulo" },
                          [
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { span: 24 }
                              },
                              [_c("span", [_vm._v(_vm._s(cruzamento[0]))])]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        _vm._l(cruzamento[1], function(i) {
                          return _c(
                            "div",
                            { staticClass: "caixa-flex border-botton" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass:
                                    "border-lefth text-center flex-center",
                                  attrs: { span: 5 }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        i.area_intersecao.toLocaleString(
                                          "pt-br",
                                          { minimumFractionDigits: 2 }
                                        ) + " ha"
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "el-col",
                                {
                                  staticClass:
                                    "border-lefth text-center flex-center",
                                  attrs: { span: 5 }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        i.pct_intersecao.toLocaleString(
                                          "pt-br",
                                          { minimumFractionDigits: 2 }
                                        ) + " %"
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "el-col",
                                {
                                  staticClass: "border-lefth",
                                  attrs: { span: 14 }
                                },
                                _vm._l(
                                  Object.entries(i)
                                    .filter(function(ref) {
                                      var e = ref[0]

                                      return !_vm.removeProp.includes(e)
                                    })
                                    .map(function(ref) {
                                      var e = ref[0]
                                      var j = ref[1]

                                      return e + ": " + j
                                    }),
                                  function(t) {
                                    return _c("div", [
                                      _c("span", [_vm._v(_vm._s(t))])
                                    ])
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        }),
        0
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_vm._v("Fechar")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49bd6662", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49bd6662","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppModalCruzamentoCamada.vue
// module id = null
// module chunks = 